import * as React from 'react';
import { Grid, Button, Alert } from '../../common';
import StandardModal from '../../common/modals/StandardModal';
import FieldHandler from '../../../models/interfaces/FieldHandler';
import UserLookup from '../../common/form-controls/Lookups/UserLookup';
import UserLookupObject from '../../../models/UserLookupObject';

interface TransferOwnershipProps {
    ownerInTransfer: FieldHandler<UserLookupObject | null>;
    newCustodian: FieldHandler<UserLookupObject | null>;
    currentCustodian: UserLookupObject | null;
    visible: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

export default class TransferAwsAccountModal extends React.Component<
    TransferOwnershipProps,
    {}
> {
    render() {
        const selectedOwner = this.props.ownerInTransfer.value;
        const currentCustodian = this.props.currentCustodian;

        const ownerIsCurrentCustodian =
            selectedOwner &&
            currentCustodian &&
            selectedOwner.id === currentCustodian.id;

        return (
            <StandardModal
                show={this.props.visible}
                onDismiss={this.props.onCancel}
                title="Transfer Ownership"
                footer={
                    <Grid variant="2up">
                        <Grid.Item>
                            <Button
                                variant="secondary"
                                onClick={this.props.onCancel}
                            >
                                Cancel
                            </Button>
                        </Grid.Item>

                        <Grid.Item>
                            <Button
                                onClick={this.props.onConfirm}
                                disabled={
                                    !this.props.ownerInTransfer.value ||
                                    (ownerIsCurrentCustodian &&
                                        !this.props.newCustodian.value)
                                }
                            >
                                Confirm
                            </Button>
                        </Grid.Item>
                    </Grid>
                }
            >
                <UserLookup
                    label="Transfer Ownership to XOM Employee"
                    isAppAdminEmployee
                    value={
                        this.props.ownerInTransfer.value?.displayName ?? ''
                    }
                    validation={this.props.ownerInTransfer.validation}
                    onChange={(user: UserLookupObject | null) => {
                        this.props.ownerInTransfer.onChange(user);

                        if (
                            user?.id !== this.props.currentCustodian?.id
                        ) {
                            this.props.newCustodian.onChange(null);
                        }
                    }}
                />

                {ownerIsCurrentCustodian && (
                    <>
                        <Alert
                            variant="warning"
                            className="no-alert-actions"
                            body="The selected owner is the current custodian. A new custodian must be selected."
                        />

                        <UserLookup
                            label="New Custodian"
                            isAppAdminEmployee
                            value={
                                this.props.newCustodian.value?.displayName ??
                                ''
                            }
                            validation={{ required: true }}
                            onChange={(user: UserLookupObject | null) => {
                                this.props.newCustodian.onChange(user);
                            }}
                        />
                    </>
                )}

                <Alert
                    variant="warning"
                    className="no-alert-actions"
                    body="Once the Application is in transfer, you will not be able to edit the Application."
                />
            </StandardModal>
        );
    }
}